__webpack_require__.p = "https://partnership-mpos-frontend-prod.ackoassets.com/next_assets/2cd764482f152394f19c6850691467c7f929a8c7/_next/";